import * as B from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as y } from "../../utilities/transformations.js";
import { grain as h } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as w } from "../../utilities/uv.js";
const R = {
  name: "Satin4",
  collection: "satin",
  tags: ["noise", "organic", "flow"],
  props: {
    colorA: {
      type: String,
      default: "#1170cf",
      transform: y
    },
    colorB: {
      type: String,
      default: "#ff9621",
      transform: y
    },
    brightness: {
      type: Number,
      default: 1
    },
    contrast: {
      type: Number,
      default: 0.3
    },
    speed: {
      type: Number,
      default: 1
    }
  },
  fragmentNode: (o) => {
    const {
      vec2: n,
      vec4: b,
      mix: i,
      sin: s,
      cos: u,
      time: S,
      uv: c,
      oneMinus: g
    } = B, d = 68, x = 2, A = 0.5, C = c().mul(x), f = (t = n(0), e) => n(
      t.x.mul(s(e)).sub(t.y.mul(u(e))),
      t.x.mul(s(e)).add(t.y.mul(u(e)))
    );
    let l = n(0), r = n(0), m = 7.5, a = C;
    for (let t = 0; t < 10; t++) {
      a = f(a, d), r = f(r, d);
      const e = a.mul(m).add(t).add(r).sub(S.mul(o.speed.uniform.mul(0.2)));
      r = r.add(s(e)), l = l.add(
        u(e).mul(0.5).add(0.5).div(m)
      ), m *= 1.22;
    }
    const p = l.x.add(l.y), N = p.mul(o.brightness.uniform.mul(1.8)).pow(3).add(p.pow(4)).sub(o.contrast.uniform.mul(0.5)).max(0), _ = i(
      o.colorA.uniform,
      o.colorB.uniform,
      c().x.mul(c().y).mul(A)
    ), { correctedUV: E } = w(), v = h(0.8)(E);
    return b(
      i(
        o.colorA.uniform.mul(g(o.contrast.uniform.mul(0.5))).sub(v.mul(0.2)),
        _,
        N
      ),
      1
    );
  }
};
export {
  R as componentDefinition,
  R as default
};
